/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Summary of kills done by the given character against enemy factions
 * @export
 * @interface GetCharactersCharacterIdFwStatsKills
 */
export interface GetCharactersCharacterIdFwStatsKills {
    /**
     * Last week's total number of kills by a given character against enemy factions
     * @type {number}
     * @memberof GetCharactersCharacterIdFwStatsKills
     */
    lastWeek: number;
    /**
     * Total number of kills by a given character against enemy factions since the character enlisted
     * @type {number}
     * @memberof GetCharactersCharacterIdFwStatsKills
     */
    total: number;
    /**
     * Yesterday's total number of kills by a given character against enemy factions
     * @type {number}
     * @memberof GetCharactersCharacterIdFwStatsKills
     */
    yesterday: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdFwStatsKills interface.
 */
export function instanceOfGetCharactersCharacterIdFwStatsKills(value: object): value is GetCharactersCharacterIdFwStatsKills {
    if (!('lastWeek' in value) || value['lastWeek'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdFwStatsKillsFromJSON(json: any): GetCharactersCharacterIdFwStatsKills {
    return GetCharactersCharacterIdFwStatsKillsFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdFwStatsKillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdFwStatsKills {
    if (json == null) {
        return json;
    }
    return {
        
        'lastWeek': json['last_week'],
        'total': json['total'],
        'yesterday': json['yesterday'],
    };
}

export function GetCharactersCharacterIdFwStatsKillsToJSON(json: any): GetCharactersCharacterIdFwStatsKills {
    return GetCharactersCharacterIdFwStatsKillsToJSONTyped(json, false);
}

export function GetCharactersCharacterIdFwStatsKillsToJSONTyped(value?: GetCharactersCharacterIdFwStatsKills | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_week': value['lastWeek'],
        'total': value['total'],
        'yesterday': value['yesterday'],
    };
}

